import { HeaderBar, ScreenLoader, UI_STYLES } from "@/components/ui";
import { motion } from "framer-motion";
import { useSubscriptionScreenViewModel } from "./SubscriptionScreenViewModel";
import ModalCenterSheet from "@/components/ui/modals/ModalCenterSheet";
import { SubscriptionConditionsModalContent } from "./ui/SubscriptionConditionsModalContent";
import { SubscriptionAproveNavigateToPaymentModalContent } from "./ui/SubscriptionAproveNavigateToPaymentModalContent";
import starsBackground from "@/assets/img/d_stars_background_2.png";
import SubscriptionScreenFree from "./ui/SubscriptionScreenFree";
import SubscriptionScreenWithPremium from "./ui/SubscriptionScreenWithPremium";
import { Helmet } from "react-helmet-async";

export default function SubscriptionScreen() {
  const {
    isConditionsOpen,
    setIsConditionsOpen,
    navigateBack,
    onSelectPlan,
    plans,
    paymentUrl,
    setPaymentUrl,
    openOffertsUrl,
    isPremium,
    currentSubscription,
    isRecurrent,
    cancelRecurrent,
    isLoading,
  } = useSubscriptionScreenViewModel();

  return (
    <>
      <Helmet>
        <title>Премиум подписка | Мир Звёзд</title>
        <meta name="description" content="Откройте полный доступ к астрологическим возможностям! Премиум подписка включает еженедельные зодиакальные прогнозы, чат с астрологом до 4 вопросов и возможность угадывать счастливую карту. Выберите подходящий тариф." />
        <meta name="keywords" content="премиум подписка, астрология, зодиакальный прогноз, чат с астрологом, счастливая карта, тарифы, астрологическая консультация, премиум доступ" />
        <meta name="author" content="bpTech" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Премиум подписка | Мир Звёзд" />
        <meta property="og:description" content="Откройте полный доступ к астрологическим возможностям! Премиум подписка включает еженедельные зодиакальные прогнозы и чат с астрологом." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://мир-звезд.рф/subscription" />
      </Helmet>
      <ScreenLoader isLoading={isLoading} />
      <ModalCenterSheet
        open={isConditionsOpen}
        backgroundUrl={starsBackground}
        onClose={() => setIsConditionsOpen(false)}
      >
        <SubscriptionConditionsModalContent
          setIsConditionsOpen={setIsConditionsOpen}
        />
      </ModalCenterSheet>

      <ModalCenterSheet
        open={paymentUrl !== null}
        onClose={() => setPaymentUrl(null)}
      >
        <SubscriptionAproveNavigateToPaymentModalContent
          url={paymentUrl || ""}
          onClose={() => setPaymentUrl(null)}
        />
      </ModalCenterSheet>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="h-full"
      >
        <div
          className={`flex flex-col relative w-screen h-full ${UI_STYLES.backgroundDarkBlue} `}
          style={{
            backgroundImage: `url(${starsBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "repeat",
          }}
        >
          <HeaderBar title="Премиум Подписка" onBack={navigateBack} />
          <div className="z-10 flex flex-col items-center p-2 w-full h-full ">
            <p className="text-center max-w-md  text-sm opacity-90 h-[100px] text-white z-10 p-4">
              Подписка позволит получать еженедельный зодиакальный
              астрологический прогноз и задать до 4 вопросов нашему астрологу. А
              также возможность угадать Счастливую карту раз в неделю.
            </p>
            <a
              href="#"
              className="underline text-cyan-300 mb-8 text-white p-2"
              onClick={() => setIsConditionsOpen(true)}
            >
              Условия подписки
            </a>
            {isPremium ? (
              <SubscriptionScreenWithPremium
                currentSubscription={currentSubscription}
                isRecurrent={isRecurrent}
                cancelRecurrent={cancelRecurrent}
              />
            ) : (
              <SubscriptionScreenFree
                onSelectPlan={onSelectPlan}
                plans={plans}
                openOffertsUrl={openOffertsUrl}
              />
            )}
          </div>
        </div>
      </motion.div>
    </>
  );
}
